import { render, staticRenderFns } from "./LdpUserDongHo.vue?vue&type=template&id=4620e0fe&scoped=true&"
import script from "./LdpUserDongHo.vue?vue&type=script&lang=js&"
export * from "./LdpUserDongHo.vue?vue&type=script&lang=js&"
import style0 from "./LdpUserDongHo.vue?vue&type=style&index=0&id=4620e0fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4620e0fe",
  null
  
)

export default component.exports